import styled from 'styled-components';
import {} from './index.js';
import React from 'react';
import { getTypographyStyles, SEM_TYPOGRAPHY_FEEDBACK_COPY, SEM_TYPOGRAPHY_FEEDBACK_HEADLINE, SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_200, SYS_SPACE_FIXED_50, getMargins } from '@oneaudi/unified-web-common';
import { Icon } from '../index.js';
import { TextLink } from '../text-link/index.js';
import { Badge } from '../badge/index.js';
import { IconButton } from '../icon-button/index.js';
export const StyledContainer = styled.div `
  display: flex;
  padding: ${SYS_SPACE_FIXED_200};
  flex-direction: column;
  background-color: ${(props) => props.theme.cmp.color.feedback.infoBox.surface.fill.default};
  color: ${(props) => props.theme.sem.color.feedback.foreground.text.default};
  margin: ${(props) => getMargins(props.margin)};

  .spacer {
    margin-top: ${SYS_SPACE_FIXED_200};
  }
`;
export const StyledTextLink = styled(TextLink) `
  margin-top: ${SYS_SPACE_FIXED_200};
  align-self: start;
`;
export const StyledTitle = styled(({ ...props }) => {
    const HtmlTag = props.tag;
    return React.createElement(HtmlTag, { ...props }, props.text);
}) `
  margin: 0 0 ${SYS_SPACE_FIXED_50} 0;
  ${getTypographyStyles(SEM_TYPOGRAPHY_FEEDBACK_HEADLINE)}
`;
export const StyledIcon = styled(Icon) `
  flex-shrink: 0;

  color: ${(props) => props.name === 'info-circle'
    ? props.theme.cmp.color.feedback.infoBox.foreground.icon.warning
    : props.name === 'select-circle'
        ? props.theme.cmp.color.feedback.infoBox.foreground.icon.success
        : props.name === 'break'
            ? props.theme.cmp.color.feedback.infoBox.foreground.icon.default
            : props.theme.cmp.color.feedback.infoBox.foreground.icon.error};
`;
export const StyledUpperContainer = styled.div `
  display: flex;
  align-items: flex-start;
  gap: ${SYS_SPACE_FIXED_100};
  width: 100%;
`;
export const StyledBadge = styled(Badge) `
  margin-top: ${SYS_SPACE_FIXED_50};
`;
export const StyledIconButton = styled(IconButton) `
  margin-left: auto;
`;
export const StyledCopy = styled.span `
  ${getTypographyStyles(SEM_TYPOGRAPHY_FEEDBACK_COPY)}
`;
export const StyledImage = styled.img `
  aspect-ratio: '16/9';
  width: 100%;
  margin-top: ${SYS_SPACE_FIXED_100};
`;
//# sourceMappingURL=index.styles.js.map